module.exports = __webpack_public_path__ + "img/blue_vee_spot.dc55e549.svg";